import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { UI_BasketItem } from '@sky/util-models';

@Component({
  selector: 'sky-ui-order-summary-item',
  templateUrl: './order-summary-item.component.html',
  styleUrls: ['./order-summary-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkyUiOrderSummaryItemComponent {
  @Input() device: UI_BasketItem | undefined;
  @Input() allowEdit = true;
  @Input() readOnly = false;
  @Output() edit: EventEmitter<string> = new EventEmitter();
  @Output() remove: EventEmitter<UI_BasketItem> = new EventEmitter();

  handleEdit(id: string) {
    this.edit.emit(id);
  }

  handleRemove(device: UI_BasketItem) {
    this.remove.emit(device);
  }
}
